import moment from "moment";

export default ({ title = "Untitled Survey" } = {}, datetime = Date.now()) =>
    `${title} ${moment(datetime).format("YYYY-MM-DD (hhmmss)")}`;
